/** @jsx jsx */
import { jsx } from 'theme-ui'
import MainFooter from './MainFooter'

const Footer = () => {
  return (
    <footer
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bottom: 0,
        width: '100%',
      }}
    >
      <MainFooter />
    </footer>
  )
}

export default Footer
